import { FormField, QuestionnaireDescription, TextareaField as Textarea } from "common";
import { noop } from "lodash";
import React from "react";
import { FieldProps } from "./TextField";

export const TextareaField = ({
    name,
    field,
    isRequired,
    classNames,
    showDescription = true,
    onChange,
}: FieldProps) => {
    return (
        <FormField label={field.label} name={name} classNames={{ label: classNames?.label }}>
            {showDescription && <QuestionnaireDescription field={field} />}
            <Textarea
                shouldAutoSize
                isRequired={isRequired}
                onChange={onChange ? (e) => onChange(e.target.value) : noop}
            />
        </FormField>
    );
};
